module.exports = __webpack_public_path__ + "img/ext9.6517365d.png";